module.exports = __webpack_public_path__ + "img/1618603298.c283eccc.png";